import React from 'react';
import '../../App.css';
import CloseIcon from "mdi-react/CloseCircleOutlineIcon"
class ErrorMessage extends React.Component {
    render() {
        return (
            <div>
                {this.props.text ? 
                    <div className="error-message" style={this.props.style}>
                        <CloseIcon size={15} style={{marginRight:10}} className="error-icon"></CloseIcon>
                        <span className="error-text">{this.props.text}</span>
                    </div>
                : null }
            </div>
        );
    }
}

export default ErrorMessage